// T-442 — encart de la fiche client : les offres d'aides reçues et chaque réponse CLASSÉE (intéressé, pas maintenant, pas intéressé, désinscription, rebond…).
// Lecture seule. Un compte sans accès au Bureau n'obtient rien du serveur : l'encart ne s'affiche pas. Jamais le texte d'un mail : un extrait borné.
import { useEffect, useState } from "react";
import { offreAides } from "./bureauAmoApi";

const muted = { color: "var(--oh-text-muted)", fontSize: 13, lineHeight: 1.6 };
const date = (iso) => { if (!iso) return ""; const d = new Date(iso); return Number.isNaN(d.getTime()) ? String(iso).slice(0, 10) : d.toLocaleDateString("fr-FR"); };

export default function OffreAidesClient({ clientId }) {
  const [e, setE] = useState(null);
  useEffect(() => {
    let vivant = true;
    offreAides.client(clientId).then((d) => { if (vivant) setE(d); }).catch(() => { if (vivant) setE(null); });
    return () => { vivant = false; };
  }, [clientId]);
  const offres = Array.isArray(e?.offres) ? e.offres : [];       // une réponse inattendue ne doit JAMAIS faire tomber la fiche client
  const reponses = Array.isArray(e?.reponses) ? e.reponses : [];
  if (!offres.length && !reponses.length) return null;
  return (
    <div data-testid="offre-client" style={{ padding: "var(--oh-space-3)", border: "0.5px solid var(--oh-border)", borderRadius: "var(--oh-radius-card)", background: "var(--oh-bg-elevated)" }}>
      <p style={{ margin: 0, fontWeight: 500, color: "var(--oh-text)", fontSize: 14 }}>Offre d'aides</p>
      <ul style={{ margin: "4px 0 0", padding: 0, listStyle: "none" }}>
        {offres.map((o) => (
          <li key={o.id} style={muted} data-testid="offre-client-offre">
            {o.type === "offre_aides_relance" ? "Relance" : "Offre"} {o.envoyee_le ? `envoyée le ${date(o.envoyee_le)}` : o.statut === "proposee" ? "prête, pas encore envoyée" : `(${o.statut})`}
            {o.mode === "capture" ? " — en essai, rien n'est parti" : ""}{o.adresse_partagee ? " — adresse partagée avec un autre client" : ""}
          </li>
        ))}
        {reponses.map((r) => (
          <li key={r.id} style={{ ...muted, color: "var(--oh-text)" }} data-testid="offre-client-reponse">
            <strong style={{ fontWeight: 500 }}>{r.libelle}</strong>{r.recue_le ? ` · ${date(r.recue_le)}` : ""}{r.extrait ? ` — « ${r.extrait.slice(0, 120)} »` : ""}
          </li>
        ))}
      </ul>
    </div>
  );
}
